import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { ServerPath } from '../../shared/constants';
import axios from 'axios';
import Spinner from '../../components/common/Spinner';
import AOS from "aos";
import "aos/dist/aos.css";

const Board = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems ] = useState([]);
  const [inititems, setInitItems ] = useState([]);
  const [total, setTotal ] = useState([]);
  const [boardType, setType] = useState('news')
  const [page, setPage] = useState(0)

  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
    
    const onInit = async () => {

      const senddata = {page : page, unit : 10}
      const token = localStorage.getItem('userToken');
      let url
      boardType === 'news'? url = '/news/list': url = '/notice/list'
      
      axios
        .post(ServerPath + url , senddata, { headers: { Authorization: `Bearer ${token}` } } )
        .then((data) => {
          if (data.data.count >=0) {
            setItems(data.data.select);
            setInitItems(data.data.select)
            setTotal(data.data.count)
          }
          setIsLoaded(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    onInit();
  }, [boardType]);

  
  const changeType = ( type ) => {
    if (type === boardType) return;
    setIsLoaded(false);
    setPage(0);
    setType(type)
  }

  const increasePage = () => {
    if (total / 10 < page + 1) return;
    setPage(page + 1);
  }

  const decreasePage = () => {
    if (page === 0) return;
    setPage(page - 1);
  }

  const linkTo = (link) => {
    navigate('/' + link);
  }

  return !isLoaded ? (
    <section>
      <div className="taps">
        <div className={ boardType==='news'?"tap_bt tapon":"tap_bt tapoff"} onClick={()=>changeType('news') }>News</div>
        <div className={ boardType==='notice'?"tap_bt tapon":"tap_bt tapoff"} onClick={()=>changeType('notice') } >Notice</div>
      </div>
      <Spinner />
    </section>
  ) : (
    <section> 
       <div className="taps">
       <div className={ boardType==='news'?"tap_bt tapon":"tap_bt tapoff"} onClick={()=>changeType('news') }>News</div>
        <div className={ boardType==='notice'?"tap_bt tapon":"tap_bt tapoff"} onClick={()=>changeType('notice') } >Notice</div>
      </div>

      <div className="bd_step1">
        <div className="mtitle"><b>MDTI {boardType.charAt(0).toUpperCase() + boardType.slice(1)}</b></div>
        <div className="album-list">
          { inititems.slice(0, 5).map((item, i) => (
              <div key={i} className="album-item" data-aos="zoom-in" onClick={() =>linkTo('board/' + boardType + '/' + item.id)}>
                <p className="album_title">{item.title_kor}</p>
                <img src={item.image_kor===''?"images/sample_img.jpg":item.image_kor} alt="" />
              </div>
          ))}
        </div>
      </div>
      <div className="bd_step2">
        <div className="mtitle"><b>HOT Issue</b>
        {page!==0?<div className="bt_more"  onClick={decreasePage}>BACK -</div> :''}
        <div className="bt_more" onClick={increasePage}>MORE +</div></div>
        
        { items.map((item, i) => (
              <div key={i} className="mlist" data-aos="fade-up" onClick={() =>linkTo('board/' + boardType + '/' + item.id)}>
                 <div className="mlist_thum" > <img src={item.image_kor} alt={"image" + i}/></div>
                <div className={boardType === 'news'?"mlist_line":"mlist_line"}>
                  <p>{item.title_kor}</p>
                  <span>{item.content_kor}</span>
                </div>
              </div>
          ))}


      </div>
    </section>
    
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser } = authUser;
  return {currentUser}
};

export default connect(mapStateToProps, null)(Board);

